/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  KPIAssignmentsPlanningResult,
  KPIAverageDrivingDistanceResult,
  KPIBookedToChangesResult,
  KPICancellationReasonResult,
  KPICancellationResult,
  KPICasesBySupplierResult,
  KPICentralStationOvernightsResult,
  KPICustomerSatisfactionResult,
  KPIDeclinedJobsResult,
  KPIDeliveredCarsResult,
  KPIDeliveryConditionResult,
  KPIDeniedAssignmentRequestsResult,
  KPIDeviationJobResult,
  KPIETAAccuracyResult,
  KPIFieldTesterTenureResult,
  KPIFieldTestersWithoutJobsResult,
  KPIFilterRequestModelBody,
  KPIGetTBParams,
  KPIHRSpeedingResult,
  KPIHotelNightsResult,
  KPIInternalDeliveryTransportMixResult,
  KPIOBDResult,
  KPIResourceUtilizationResult,
  KPIResult,
  KPITransportLeadTimeResult,
  KPITruckCoverageResult,
  KPIUniqueAssigneesResult,
  KPIVehicleFaultResult,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useKPIGetTBHook = () => {
  const kPIGetTB = useCustomInstance<KPIResult>();

  return useCallback(
    (params?: KPIGetTBParams, signal?: AbortSignal) => {
      return kPIGetTB({ url: `/api/KPI/GetTB`, method: 'GET', params, signal });
    },
    [kPIGetTB]
  );
};

export const getKPIGetTBQueryKey = (params?: KPIGetTBParams) => {
  return [`/api/KPI/GetTB`, ...(params ? [params] : [])] as const;
};

export const useKPIGetTBQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useKPIGetTBHook>>>,
  TError = unknown,
>(
  params?: KPIGetTBParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useKPIGetTBHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getKPIGetTBQueryKey(params);

  const kPIGetTB = useKPIGetTBHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTBHook>>>
  > = ({ signal }) => kPIGetTB(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTBHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type KPIGetTBQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetTBHook>>>
>;
export type KPIGetTBQueryError = unknown;

export const useKPIGetTB = <
  TData = Awaited<ReturnType<ReturnType<typeof useKPIGetTBHook>>>,
  TError = unknown,
>(
  params?: KPIGetTBParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useKPIGetTBHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useKPIGetTBQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useKPIGetOBDNotUsedHook = () => {
  const kPIGetOBDNotUsed = useCustomInstance<KPIOBDResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetOBDNotUsed({
        url: `/api/KPI/GetOBDNotUsed`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetOBDNotUsed]
  );
};

export const useKPIGetOBDNotUsedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetOBDNotUsedHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetOBDNotUsedHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetOBDNotUsed = useKPIGetOBDNotUsedHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetOBDNotUsedHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetOBDNotUsed(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetOBDNotUsedMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetOBDNotUsedHook>>>
>;
export type KPIGetOBDNotUsedMutationBody = KPIFilterRequestModelBody;
export type KPIGetOBDNotUsedMutationError = unknown;

export const useKPIGetOBDNotUsed = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetOBDNotUsedHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetOBDNotUsedHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetOBDNotUsedMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetCancellationsByBookerHook = () => {
  const kPIGetCancellationsByBooker =
    useCustomInstance<KPICancellationResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetCancellationsByBooker({
        url: `/api/KPI/GetCancellationsByBooker`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetCancellationsByBooker]
  );
};

export const useKPIGetCancellationsByBookerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByBookerHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByBookerHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetCancellationsByBooker = useKPIGetCancellationsByBookerHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByBookerHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetCancellationsByBooker(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetCancellationsByBookerMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByBookerHook>>>
>;
export type KPIGetCancellationsByBookerMutationBody = KPIFilterRequestModelBody;
export type KPIGetCancellationsByBookerMutationError = unknown;

export const useKPIGetCancellationsByBooker = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByBookerHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByBookerHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetCancellationsByBookerMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetDeviationJobsByBookerHook = () => {
  const kPIGetDeviationJobsByBooker =
    useCustomInstance<KPIDeviationJobResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetDeviationJobsByBooker({
        url: `/api/KPI/GetDeviationJobsByBooker`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetDeviationJobsByBooker]
  );
};

export const useKPIGetDeviationJobsByBookerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeviationJobsByBookerHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeviationJobsByBookerHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetDeviationJobsByBooker = useKPIGetDeviationJobsByBookerHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeviationJobsByBookerHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetDeviationJobsByBooker(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetDeviationJobsByBookerMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeviationJobsByBookerHook>>>
>;
export type KPIGetDeviationJobsByBookerMutationBody = KPIFilterRequestModelBody;
export type KPIGetDeviationJobsByBookerMutationError = unknown;

export const useKPIGetDeviationJobsByBooker = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeviationJobsByBookerHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeviationJobsByBookerHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetDeviationJobsByBookerMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetVehicleFaultsByTesterHook = () => {
  const kPIGetVehicleFaultsByTester =
    useCustomInstance<KPIVehicleFaultResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetVehicleFaultsByTester({
        url: `/api/KPI/GetVehicleFaultsByTester`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetVehicleFaultsByTester]
  );
};

export const useKPIGetVehicleFaultsByTesterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetVehicleFaultsByTesterHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetVehicleFaultsByTesterHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetVehicleFaultsByTester = useKPIGetVehicleFaultsByTesterHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetVehicleFaultsByTesterHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetVehicleFaultsByTester(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetVehicleFaultsByTesterMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetVehicleFaultsByTesterHook>>>
>;
export type KPIGetVehicleFaultsByTesterMutationBody = KPIFilterRequestModelBody;
export type KPIGetVehicleFaultsByTesterMutationError = unknown;

export const useKPIGetVehicleFaultsByTester = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetVehicleFaultsByTesterHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetVehicleFaultsByTesterHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetVehicleFaultsByTesterMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetDeliveryConditionByBookerHook = () => {
  const kPIGetDeliveryConditionByBooker =
    useCustomInstance<KPIDeliveryConditionResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetDeliveryConditionByBooker({
        url: `/api/KPI/GetDeliveryConditionByBooker`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetDeliveryConditionByBooker]
  );
};

export const useKPIGetDeliveryConditionByBookerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetDeliveryConditionByBookerHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetDeliveryConditionByBookerHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetDeliveryConditionByBooker =
    useKPIGetDeliveryConditionByBookerHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetDeliveryConditionByBookerHook>>
    >,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetDeliveryConditionByBooker(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetDeliveryConditionByBookerMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeliveryConditionByBookerHook>>>
>;
export type KPIGetDeliveryConditionByBookerMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetDeliveryConditionByBookerMutationError = unknown;

export const useKPIGetDeliveryConditionByBooker = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetDeliveryConditionByBookerHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetDeliveryConditionByBookerHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetDeliveryConditionByBookerMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetETAAccuracyHook = () => {
  const kPIGetETAAccuracy = useCustomInstance<KPIETAAccuracyResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetETAAccuracy({
        url: `/api/KPI/GetETAAccuracy`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetETAAccuracy]
  );
};

export const useKPIGetETAAccuracyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetETAAccuracyHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetETAAccuracyHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetETAAccuracy = useKPIGetETAAccuracyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetETAAccuracyHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetETAAccuracy(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetETAAccuracyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetETAAccuracyHook>>>
>;
export type KPIGetETAAccuracyMutationBody = KPIFilterRequestModelBody;
export type KPIGetETAAccuracyMutationError = unknown;

export const useKPIGetETAAccuracy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetETAAccuracyHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetETAAccuracyHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetETAAccuracyMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetAssignmentsPlannedByAdminHook = () => {
  const kPIGetAssignmentsPlannedByAdmin =
    useCustomInstance<KPIAssignmentsPlanningResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetAssignmentsPlannedByAdmin({
        url: `/api/KPI/GetAssignmentsPlannedByAdmin`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetAssignmentsPlannedByAdmin]
  );
};

export const useKPIGetAssignmentsPlannedByAdminMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetAssignmentsPlannedByAdminHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetAssignmentsPlannedByAdminHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetAssignmentsPlannedByAdmin =
    useKPIGetAssignmentsPlannedByAdminHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetAssignmentsPlannedByAdminHook>>
    >,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetAssignmentsPlannedByAdmin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetAssignmentsPlannedByAdminMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetAssignmentsPlannedByAdminHook>>>
>;
export type KPIGetAssignmentsPlannedByAdminMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetAssignmentsPlannedByAdminMutationError = unknown;

export const useKPIGetAssignmentsPlannedByAdmin = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetAssignmentsPlannedByAdminHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetAssignmentsPlannedByAdminHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetAssignmentsPlannedByAdminMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetUniqueAssigneesByAdminHook = () => {
  const kPIGetUniqueAssigneesByAdmin =
    useCustomInstance<KPIUniqueAssigneesResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetUniqueAssigneesByAdmin({
        url: `/api/KPI/GetUniqueAssigneesByAdmin`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetUniqueAssigneesByAdmin]
  );
};

export const useKPIGetUniqueAssigneesByAdminMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetUniqueAssigneesByAdminHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetUniqueAssigneesByAdminHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetUniqueAssigneesByAdmin = useKPIGetUniqueAssigneesByAdminHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetUniqueAssigneesByAdminHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetUniqueAssigneesByAdmin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetUniqueAssigneesByAdminMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetUniqueAssigneesByAdminHook>>>
>;
export type KPIGetUniqueAssigneesByAdminMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetUniqueAssigneesByAdminMutationError = unknown;

export const useKPIGetUniqueAssigneesByAdmin = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetUniqueAssigneesByAdminHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetUniqueAssigneesByAdminHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetUniqueAssigneesByAdminMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetDeliveredCarsHook = () => {
  const kPIGetDeliveredCars = useCustomInstance<KPIDeliveredCarsResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetDeliveredCars({
        url: `/api/KPI/GetDeliveredCars`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetDeliveredCars]
  );
};

export const useKPIGetDeliveredCarsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeliveredCarsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeliveredCarsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetDeliveredCars = useKPIGetDeliveredCarsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeliveredCarsHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetDeliveredCars(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetDeliveredCarsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeliveredCarsHook>>>
>;
export type KPIGetDeliveredCarsMutationBody = KPIFilterRequestModelBody;
export type KPIGetDeliveredCarsMutationError = unknown;

export const useKPIGetDeliveredCars = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeliveredCarsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeliveredCarsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetDeliveredCarsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetInternalDeliveryTransportMixHook = () => {
  const kPIGetInternalDeliveryTransportMix =
    useCustomInstance<KPIInternalDeliveryTransportMixResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetInternalDeliveryTransportMix({
        url: `/api/KPI/GetInternalDeliveryTransportMix`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetInternalDeliveryTransportMix]
  );
};

export const useKPIGetInternalDeliveryTransportMixMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetInternalDeliveryTransportMixHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetInternalDeliveryTransportMixHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetInternalDeliveryTransportMix =
    useKPIGetInternalDeliveryTransportMixHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetInternalDeliveryTransportMixHook>>
    >,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetInternalDeliveryTransportMix(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetInternalDeliveryTransportMixMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetInternalDeliveryTransportMixHook>>
  >
>;
export type KPIGetInternalDeliveryTransportMixMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetInternalDeliveryTransportMixMutationError = unknown;

export const useKPIGetInternalDeliveryTransportMix = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetInternalDeliveryTransportMixHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetInternalDeliveryTransportMixHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetInternalDeliveryTransportMixMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetCustomerSatisfactionByCaseTypeHook = () => {
  const kPIGetCustomerSatisfactionByCaseType =
    useCustomInstance<KPICustomerSatisfactionResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetCustomerSatisfactionByCaseType({
        url: `/api/KPI/GetCustomerSatisfactionByCaseType`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetCustomerSatisfactionByCaseType]
  );
};

export const useKPIGetCustomerSatisfactionByCaseTypeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetCustomerSatisfactionByCaseTypeHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetCustomerSatisfactionByCaseTypeHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetCustomerSatisfactionByCaseType =
    useKPIGetCustomerSatisfactionByCaseTypeHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetCustomerSatisfactionByCaseTypeHook>>
    >,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetCustomerSatisfactionByCaseType(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetCustomerSatisfactionByCaseTypeMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetCustomerSatisfactionByCaseTypeHook>>
  >
>;
export type KPIGetCustomerSatisfactionByCaseTypeMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetCustomerSatisfactionByCaseTypeMutationError = unknown;

export const useKPIGetCustomerSatisfactionByCaseType = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetCustomerSatisfactionByCaseTypeHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useKPIGetCustomerSatisfactionByCaseTypeHook>>
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetCustomerSatisfactionByCaseTypeMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetCancellationsByReasonHook = () => {
  const kPIGetCancellationsByReason =
    useCustomInstance<KPICancellationReasonResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetCancellationsByReason({
        url: `/api/KPI/GetCancellationsByReason`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetCancellationsByReason]
  );
};

export const useKPIGetCancellationsByReasonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByReasonHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByReasonHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetCancellationsByReason = useKPIGetCancellationsByReasonHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByReasonHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetCancellationsByReason(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetCancellationsByReasonMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByReasonHook>>>
>;
export type KPIGetCancellationsByReasonMutationBody = KPIFilterRequestModelBody;
export type KPIGetCancellationsByReasonMutationError = unknown;

export const useKPIGetCancellationsByReason = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByReasonHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCancellationsByReasonHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetCancellationsByReasonMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetBookedToChangesHook = () => {
  const kPIGetBookedToChanges = useCustomInstance<KPIBookedToChangesResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetBookedToChanges({
        url: `/api/KPI/GetBookedToChanges`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetBookedToChanges]
  );
};

export const useKPIGetBookedToChangesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetBookedToChangesHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetBookedToChangesHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetBookedToChanges = useKPIGetBookedToChangesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetBookedToChangesHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetBookedToChanges(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetBookedToChangesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetBookedToChangesHook>>>
>;
export type KPIGetBookedToChangesMutationBody = KPIFilterRequestModelBody;
export type KPIGetBookedToChangesMutationError = unknown;

export const useKPIGetBookedToChanges = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetBookedToChangesHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetBookedToChangesHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetBookedToChangesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetTruckCoverageHook = () => {
  const kPIGetTruckCoverage = useCustomInstance<KPITruckCoverageResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetTruckCoverage({
        url: `/api/KPI/GetTruckCoverage`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetTruckCoverage]
  );
};

export const useKPIGetTruckCoverageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTruckCoverageHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetTruckCoverageHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetTruckCoverage = useKPIGetTruckCoverageHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTruckCoverageHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetTruckCoverage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetTruckCoverageMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetTruckCoverageHook>>>
>;
export type KPIGetTruckCoverageMutationBody = KPIFilterRequestModelBody;
export type KPIGetTruckCoverageMutationError = unknown;

export const useKPIGetTruckCoverage = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTruckCoverageHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetTruckCoverageHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetTruckCoverageMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetResourceUtilizationHook = () => {
  const kPIGetResourceUtilization =
    useCustomInstance<KPIResourceUtilizationResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetResourceUtilization({
        url: `/api/KPI/GetResourceUtilization`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetResourceUtilization]
  );
};

export const useKPIGetResourceUtilizationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetResourceUtilizationHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetResourceUtilizationHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetResourceUtilization = useKPIGetResourceUtilizationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetResourceUtilizationHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetResourceUtilization(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetResourceUtilizationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetResourceUtilizationHook>>>
>;
export type KPIGetResourceUtilizationMutationBody = KPIFilterRequestModelBody;
export type KPIGetResourceUtilizationMutationError = unknown;

export const useKPIGetResourceUtilization = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetResourceUtilizationHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetResourceUtilizationHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetResourceUtilizationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetTransportLeadTimeHook = () => {
  const kPIGetTransportLeadTime =
    useCustomInstance<KPITransportLeadTimeResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetTransportLeadTime({
        url: `/api/KPI/GetTransportLeadTime`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetTransportLeadTime]
  );
};

export const useKPIGetTransportLeadTimeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTransportLeadTimeHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetTransportLeadTimeHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetTransportLeadTime = useKPIGetTransportLeadTimeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTransportLeadTimeHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetTransportLeadTime(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetTransportLeadTimeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetTransportLeadTimeHook>>>
>;
export type KPIGetTransportLeadTimeMutationBody = KPIFilterRequestModelBody;
export type KPIGetTransportLeadTimeMutationError = unknown;

export const useKPIGetTransportLeadTime = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetTransportLeadTimeHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetTransportLeadTimeHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetTransportLeadTimeMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetCasesBySupplierHook = () => {
  const kPIGetCasesBySupplier = useCustomInstance<KPICasesBySupplierResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetCasesBySupplier({
        url: `/api/KPI/GetCasesBySupplier`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetCasesBySupplier]
  );
};

export const useKPIGetCasesBySupplierMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCasesBySupplierHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCasesBySupplierHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetCasesBySupplier = useKPIGetCasesBySupplierHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCasesBySupplierHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetCasesBySupplier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetCasesBySupplierMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCasesBySupplierHook>>>
>;
export type KPIGetCasesBySupplierMutationBody = KPIFilterRequestModelBody;
export type KPIGetCasesBySupplierMutationError = unknown;

export const useKPIGetCasesBySupplier = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetCasesBySupplierHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCasesBySupplierHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetCasesBySupplierMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetHotelNightsHook = () => {
  const kPIGetHotelNights = useCustomInstance<KPIHotelNightsResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetHotelNights({
        url: `/api/KPI/GetHotelNights`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetHotelNights]
  );
};

export const useKPIGetHotelNightsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetHotelNightsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetHotelNightsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetHotelNights = useKPIGetHotelNightsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetHotelNightsHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetHotelNights(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetHotelNightsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetHotelNightsHook>>>
>;
export type KPIGetHotelNightsMutationBody = KPIFilterRequestModelBody;
export type KPIGetHotelNightsMutationError = unknown;

export const useKPIGetHotelNights = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetHotelNightsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetHotelNightsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetHotelNightsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetFieldTestersWithoutJobsHook = () => {
  const kPIGetFieldTestersWithoutJobs =
    useCustomInstance<KPIFieldTestersWithoutJobsResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetFieldTestersWithoutJobs({
        url: `/api/KPI/GetFieldTestersWithoutJobs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetFieldTestersWithoutJobs]
  );
};

export const useKPIGetFieldTestersWithoutJobsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetFieldTestersWithoutJobsHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTestersWithoutJobsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetFieldTestersWithoutJobs = useKPIGetFieldTestersWithoutJobsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetFieldTestersWithoutJobsHook>>
    >,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetFieldTestersWithoutJobs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetFieldTestersWithoutJobsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTestersWithoutJobsHook>>>
>;
export type KPIGetFieldTestersWithoutJobsMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetFieldTestersWithoutJobsMutationError = unknown;

export const useKPIGetFieldTestersWithoutJobs = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetFieldTestersWithoutJobsHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTestersWithoutJobsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetFieldTestersWithoutJobsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetDeniedAssignmentRequestsHook = () => {
  const kPIGetDeniedAssignmentRequests =
    useCustomInstance<KPIDeniedAssignmentRequestsResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetDeniedAssignmentRequests({
        url: `/api/KPI/GetDeniedAssignmentRequests`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetDeniedAssignmentRequests]
  );
};

export const useKPIGetDeniedAssignmentRequestsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetDeniedAssignmentRequestsHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeniedAssignmentRequestsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetDeniedAssignmentRequests =
    useKPIGetDeniedAssignmentRequestsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetDeniedAssignmentRequestsHook>>
    >,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetDeniedAssignmentRequests(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetDeniedAssignmentRequestsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeniedAssignmentRequestsHook>>>
>;
export type KPIGetDeniedAssignmentRequestsMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetDeniedAssignmentRequestsMutationError = unknown;

export const useKPIGetDeniedAssignmentRequests = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetDeniedAssignmentRequestsHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeniedAssignmentRequestsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetDeniedAssignmentRequestsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetDeclinedJobsHook = () => {
  const kPIGetDeclinedJobs = useCustomInstance<KPIDeclinedJobsResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetDeclinedJobs({
        url: `/api/KPI/GetDeclinedJobs`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetDeclinedJobs]
  );
};

export const useKPIGetDeclinedJobsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeclinedJobsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeclinedJobsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetDeclinedJobs = useKPIGetDeclinedJobsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeclinedJobsHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetDeclinedJobs(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetDeclinedJobsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeclinedJobsHook>>>
>;
export type KPIGetDeclinedJobsMutationBody = KPIFilterRequestModelBody;
export type KPIGetDeclinedJobsMutationError = unknown;

export const useKPIGetDeclinedJobs = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetDeclinedJobsHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetDeclinedJobsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetDeclinedJobsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetFieldTesterTenureHook = () => {
  const kPIGetFieldTesterTenure =
    useCustomInstance<KPIFieldTesterTenureResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetFieldTesterTenure({
        url: `/api/KPI/GetFieldTesterTenure`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetFieldTesterTenure]
  );
};

export const useKPIGetFieldTesterTenureMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTesterTenureHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTesterTenureHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetFieldTesterTenure = useKPIGetFieldTesterTenureHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTesterTenureHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetFieldTesterTenure(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetFieldTesterTenureMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTesterTenureHook>>>
>;
export type KPIGetFieldTesterTenureMutationBody = KPIFilterRequestModelBody;
export type KPIGetFieldTesterTenureMutationError = unknown;

export const useKPIGetFieldTesterTenure = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTesterTenureHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetFieldTesterTenureHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetFieldTesterTenureMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetCentralStationOvernightsHook = () => {
  const kPIGetCentralStationOvernights =
    useCustomInstance<KPICentralStationOvernightsResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetCentralStationOvernights({
        url: `/api/KPI/GetCentralStationOvernights`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetCentralStationOvernights]
  );
};

export const useKPIGetCentralStationOvernightsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetCentralStationOvernightsHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCentralStationOvernightsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetCentralStationOvernights =
    useKPIGetCentralStationOvernightsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetCentralStationOvernightsHook>>
    >,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetCentralStationOvernights(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetCentralStationOvernightsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCentralStationOvernightsHook>>>
>;
export type KPIGetCentralStationOvernightsMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetCentralStationOvernightsMutationError = unknown;

export const useKPIGetCentralStationOvernights = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useKPIGetCentralStationOvernightsHook>>
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetCentralStationOvernightsHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetCentralStationOvernightsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIGetHRSpeedingReportHook = () => {
  const kPIGetHRSpeedingReport = useCustomInstance<KPIHRSpeedingResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetHRSpeedingReport({
        url: `/api/KPI/GetHRSpeedingReport`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetHRSpeedingReport]
  );
};

export const useKPIGetHRSpeedingReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetHRSpeedingReportHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKPIGetHRSpeedingReportHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const kPIGetHRSpeedingReport = useKPIGetHRSpeedingReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIGetHRSpeedingReportHook>>>,
    { data: KPIFilterRequestModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return kPIGetHRSpeedingReport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type KPIGetHRSpeedingReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIGetHRSpeedingReportHook>>>
>;
export type KPIGetHRSpeedingReportMutationBody = KPIFilterRequestModelBody;
export type KPIGetHRSpeedingReportMutationError = unknown;

export const useKPIGetHRSpeedingReport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIGetHRSpeedingReportHook>>>,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKPIGetHRSpeedingReportHook>>>,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions = useKPIGetHRSpeedingReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useKPIIsHRSpeedingReportEnabledHook = () => {
  const kPIIsHRSpeedingReportEnabled = useCustomInstance<boolean>();

  return useCallback(
    (signal?: AbortSignal) => {
      return kPIIsHRSpeedingReportEnabled({
        url: `/api/KPI/IsHRSpeedingReportEnabled`,
        method: 'GET',
        signal,
      });
    },
    [kPIIsHRSpeedingReportEnabled]
  );
};

export const getKPIIsHRSpeedingReportEnabledQueryKey = () => {
  return [`/api/KPI/IsHRSpeedingReportEnabled`] as const;
};

export const useKPIIsHRSpeedingReportEnabledQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useKPIIsHRSpeedingReportEnabledHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIIsHRSpeedingReportEnabledHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getKPIIsHRSpeedingReportEnabledQueryKey();

  const kPIIsHRSpeedingReportEnabled = useKPIIsHRSpeedingReportEnabledHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useKPIIsHRSpeedingReportEnabledHook>>>
  > = ({ signal }) => kPIIsHRSpeedingReportEnabled(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIIsHRSpeedingReportEnabledHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type KPIIsHRSpeedingReportEnabledQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKPIIsHRSpeedingReportEnabledHook>>>
>;
export type KPIIsHRSpeedingReportEnabledQueryError = unknown;

export const useKPIIsHRSpeedingReportEnabled = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useKPIIsHRSpeedingReportEnabledHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useKPIIsHRSpeedingReportEnabledHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useKPIIsHRSpeedingReportEnabledQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook = () => {
  const kPIGetAverageDrivingDistanceByCaseTypeAndCounty =
    useCustomInstance<KPIAverageDrivingDistanceResult>();

  return useCallback(
    (kPIFilterRequestModelBody: KPIFilterRequestModelBody) => {
      return kPIGetAverageDrivingDistanceByCaseTypeAndCounty({
        url: `/api/KPI/GetAverageDrivingDistanceByCaseTypeAndCounty`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: kPIFilterRequestModelBody,
      });
    },
    [kPIGetAverageDrivingDistanceByCaseTypeAndCounty]
  );
};

export const useKPIGetAverageDrivingDistanceByCaseTypeAndCountyMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook
          >
        >
      >,
      TError,
      { data: KPIFilterRequestModelBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook
        >
      >
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const kPIGetAverageDrivingDistanceByCaseTypeAndCounty =
      useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook
          >
        >
      >,
      { data: KPIFilterRequestModelBody }
    > = (props) => {
      const { data } = props ?? {};

      return kPIGetAverageDrivingDistanceByCaseTypeAndCounty(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type KPIGetAverageDrivingDistanceByCaseTypeAndCountyMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook
        >
      >
    >
  >;
export type KPIGetAverageDrivingDistanceByCaseTypeAndCountyMutationBody =
  KPIFilterRequestModelBody;
export type KPIGetAverageDrivingDistanceByCaseTypeAndCountyMutationError =
  unknown;

export const useKPIGetAverageDrivingDistanceByCaseTypeAndCounty = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook
        >
      >
    >,
    TError,
    { data: KPIFilterRequestModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useKPIGetAverageDrivingDistanceByCaseTypeAndCountyHook>
    >
  >,
  TError,
  { data: KPIFilterRequestModelBody },
  TContext
> => {
  const mutationOptions =
    useKPIGetAverageDrivingDistanceByCaseTypeAndCountyMutationOptions(options);

  return useMutation(mutationOptions);
};
